<template>
  <v-card class="mx-auto greyBackground" flat>
    <v-card-title class="justify-center headline font-weight-regular py-7">{{ formTitle }}</v-card-title>
    <v-divider class="secondary"></v-divider>

     <v-window v-model="step">
      <v-window-item :value="1">
    <v-card-text class="text-center">
      <v-form
        ref="contactForm"
        v-model="valid"
        lazy-validation
        @submit.prevent="sendContactMessage()"
      >
        <v-row class="mx-10">
          <!-- The Name Of the user -->
          <v-col cols="12" xs="12" sm="12" md="12">
            <v-text-field
              v-model="contact_name"
              solo
              label="Enter your Name"
              append-icon="icons8-male-user"
              hide-details="auto"
              :rules="nameRules"
              required
            ></v-text-field>
          </v-col>

          <!-- The email Of the user -->
          <v-col cols="12" xs="12" sm="12" md="12">
            <v-text-field
              v-model="contact_email"
              solo
              label="Enter your email"
              append-icon="icons8-envelope-3"
              hide-details="auto"
              :rules="emailRules"
              required
            ></v-text-field>
          </v-col>

          <!-- The subject Of the user -->
          <v-col cols="12" xs="12" sm="12" md="12">
            <v-text-field
              v-model="contact_subject"
              solo
              label="Enter subject"
              append-icon="icons8-name-tag"
              hide-details="auto"
              :rules="subjectRules"
              required
            ></v-text-field>
          </v-col>

          <!-- The message Of the user -->
          <v-col cols="12" xs="12" sm="12" md="12">
            <v-textarea
              v-model="contact_message"
              solo
              label="Write Your message"
              hide-details="auto"
              :rules="messageRules"
              required
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions class="justify-center">
      <v-btn class="mx-2" dark color="primary" @click="sendContactMessage()" type="submit">SUBMIT</v-btn>

      <v-btn class="mx-2" dark color="primary" @click="clear">clear</v-btn>
    </v-card-actions>
      </v-window-item>
      <v-window-item :value="2">
        <p
                  class="text-center caption grey--text text--darken-1 pa-1"
                  style="text-align: center!important"
                  
                >
              Thank you for contacting us, we will get back to you as soon as we can.
                </p>
      </v-window-item>
     </v-window>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    step:1,
    valid: true,
    contact_name: "",
    contact_email: "",
    contact_subject: "",
    contact_message: "",
    contact_notice: "",

    nameRules: [(v) => !!v || "Full name is required"],
    emailRules: [(v) => !!v || "Email is required"],
    subjectRules: [(v) => !!v || "Email is required"],
    messageRules: [(v) => !!v || "Email is required"],
  }),
  computed: {
     formTitle() {
      if (this.step === 1) {
        return "CONTACT US";
      } else if (this.step === 2) {
        return "Message Sent Successfully! " 
      } else {
        return "NEW RESOURCE FOR " + this.FormTopic.name;
      }
    },
  },
  methods: {
    sendContactMessage() {
      //console.log("in the fuctuions");
      if (!this.validEmail(this.contact_email)) {
        this.contact_notice = "The email address is badly formatted.";
        //console.log("bad email");
      } else if (this.contact_message.length < 10) {
        this.contact_notice = "Your message is too short";
       // console.log("small text");
        } else {
        const url = `https://us-central1-thesciencecapital.cloudfunctions.net/sendEmail?email_from=${this.contact_email}&message=${this.contact_message}&subjectForm=${this.contact_subject}&nameUser=${this.contact_name}`;
       // console.log("url: " + url);
        const requestOptions = {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        };
        fetch(url, requestOptions);
        this.step++;
      }
    },
    validEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    clear() {
      this.contact_name = "";
      this.contact_email = "";
      this.contact_subject = "";
      this.contact_message = "";
    },
  },
};
</script>